import { createSvgIcon } from 'src/components/Icons/utils';

export default createSvgIcon(
  <path d="M15 20H7v-2h2.927l2.116-12H9V4h8v2h-2.927l-2.116 12H15z" />,
  'Italic',
  '0 0 24 24'
);
